import { cn } from '@/utlis/cn'
import {
    getCurrentGalleryPage,
    getPinInfo,
    sessionViewModeState,
    ViewMode,
} from '@/pages/SessionPage/internal/shared/useViewMode'
import { Button } from '@/UIComponents2/Button'
import LeftChevronIcon from '@/CustomIcons/LeftChevron'
import RightChevronIcon from '@/CustomIcons/RightChervron'
import * as Constants from '@/services/Constants'

type VideoGridPaginationProps = {
    viewMode: ViewMode
    numVideos: number
}
export function VideoGridPagination(props: VideoGridPaginationProps) {
    if (getPinInfo(props.viewMode) !== null) {
        return null
    }

    if (props.numVideos <= Constants.max_videos_per_page) {
        return null
    }

    const currentPage = getCurrentGalleryPage(props.viewMode)
    const lastPage = Math.ceil(props.numVideos / Constants.max_videos_per_page) - 1
    const pageNum = (
        <div>
            <span>{currentPage + 1}</span>
            <span className="font-light opacity-65">/{lastPage + 1}</span>
        </div>
    )

    const pos = 'absolute top-[50%] translate-y-[-50%] z-15'
    const style =
        'backdrop-blur-sm bg-black/40 hover:bg-white/10 h-[100px] flex items-center justify-center text-[12px] border-muse-toplit-low'
    return (
        <>
            {currentPage !== 0 && (
                <Button
                    className={cn(pos, 'left-0', style, 'rounded-r-[32px] pl-[6px] pr-[9px]')}
                    onClick={() => sessionViewModeState.galleryPagePrev()}
                >
                    <LeftChevronIcon style={{ fontSize: '1.3rem' }} />
                    {pageNum}
                </Button>
            )}
            {currentPage !== lastPage && (
                <Button
                    className={cn(pos, 'right-0', style, 'rounded-l-[32px] pr-[6px] pl-[9px]')}
                    onClick={() => sessionViewModeState.galleryPageNext()}
                >
                    {pageNum}
                    <RightChevronIcon style={{ fontSize: '1.3rem' }} />
                </Button>
            )}
        </>
    )
}
